import { Send } from "lucide-react";
import { useState } from "react";

interface FollowUpInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export function FollowUpInput({ onSend, disabled }: FollowUpInputProps) {
  const [value, setValue] = useState("");

  const handleSend = () => {
    if (value.trim() && !disabled) {
      onSend(value.trim());
      setValue("");
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSend()}
        placeholder="Ask a follow-up question..."
        disabled={disabled}
        className="w-full bg-card border border-rule rounded-xl py-3 px-4 pr-12 text-sm text-ink placeholder:text-ink-muted/50 focus:outline-none focus:ring-2 focus:ring-neon-blue/20 focus:border-neon-blue/40 shadow-sm disabled:opacity-50"
      />
      <button
        onClick={handleSend}
        disabled={!value.trim() || disabled}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-2 bg-brand/5 hover:bg-brand/10 text-brand rounded-lg transition-colors disabled:opacity-30"
      >
        <Send className="size-4" />
      </button>
    </div>
  );
}
